angular.module('app.controllers.non-paginated-forms.email-us', ['ui.mask'])
    .controller("EmailUsController", function ($scope, $window, $http, appConstants) {
        $scope.aversion = appConstants.version;
        $scope.form_name = "Email Us";
        $scope.form_processed = "";
        $scope.caprequired = appConstants.captchaRequired;
        $scope.patterns = appConstants.patterns;
        $scope.form_info = [
            "If you have an emergency, please do not use this form. Call 877-860-6020 if you have an emergency" +
            " or safety related issue."
        ];
        $scope.success_response = [
            "Your inquiry has been successfully sent."
        ];
        $scope.success_detail = [
            "Thank you for contacting Southwest Gas. Your concerns and comments are important to us and we will respond within" +
            " three business days. Our normal business hours are 8am-5pm Monday through Friday excluding holidays."
        ];

        $scope.ssnneeded = true;
        $scope.$watch('subject', function (value) {
            if (!value || value === 'SW' || value === 'EO' || value === '') {
                $scope.ssnneeded = false;
            }
            else {
                $scope.ssnneeded = true;
            }
        });

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
        };

        $scope.resetForm = function () {
            $scope.firstname = "";
            $scope.lastname = "";
            $scope.address = "";
            $scope.city = "";
            $scope.state = "";
            $scope.zipcode = "";
            $scope.phonenum = "";
            $scope.email = "";
            $scope.subject = "";
            $scope.division = "";
            $scope.account = "";
            $scope.ssn = "";
            $scope.comments = "";
            $scope.ssnneeded = true;

            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.hasError = function(field) {
            return field.$invalid && (field.$touched || field.$dirty);
        };

        $scope.isEmpty = function(field) {
            return field.$$rawModelValue === '' && (field.$touched || field.$dirty);
        };

        $scope.getStateClass = function(field) {
            if (field.$touched || field.$dirty) {
                return field.$valid ? 'has-success' : 'has-error';
            }

            return null;
        };

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                
                // Required fields
                var firstName = $scope.firstname;
                var lastName = $scope.lastname;
                var address = $scope.address;
                var city = $scope.city;
                var email = $scope.email;
                var subject = $scope.subject;

                // Optional fields
                var state = $scope.state;
                var phone = $scope.phonenum;
                var zip = $scope.zipcode;
                var division = (subject == 'SW' || subject == 'EO') ? 'CRP' : $scope.division;
                var accountNumber = $scope.account;
                var lastFourDigitsOfSsn = $scope.ssn;
                var comments = $scope.comments;

                $.ajax({
                    url: "/swgasws/resources/form/emailus/add",
                    type: "post",
                    dataType: 'json',
                    data: {
                        firstName: firstName,
                        lastName: lastName,
                        address: address,
                        city: city,
                        state: state,
                        zip: zip,
                        phone: phone,
                        email: email,
                        subject: subject,
                        division: division,
                        accountNumber: accountNumber,
                        lastFourDigitsOfSsn: lastFourDigitsOfSsn,
                        comments: comments.replace(/"/g, "'"),
                        gRecaptchaResponse: grecaptcha.getResponse()
                    },
                    success: function (data) {

                        switch (data.status) {
                            case 'success':
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-good'>" + data.message + "</span><br /><br /><span class='form-sub-normal'> Thank you for contacting Southwest Gas. Your concerns and comments are important to us and we will respond within three business days.</span></p>";
                                break;
                            case 'badrequest':
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " Please try again later.  The Webmaster has been notified of the following submission problem(s): <br /> " + data.sysmessage + "</span></p>";
                                break;
                            default:  // all other errors
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of this submission problem.</span></p>";
                        }

                        $scope.isDisabled = !0;
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    },
                    error: function (response) {
                        document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your Contact Us inquiry has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    }
                });
            }
        };
    });